import wrappedFetch from './base';

const fetchValidationSchemas = () => {
  return wrappedFetch('/json/validation_schema.json?version=86')
    .then((response) => response.json());
};

export default fetchValidationSchemas;
